<div class="viewer-print d-flex flex-column">
  <span class="align-self-center viewer-print-label">Print</span>
  <div class="viewer-print-button">
    <zbp-button-component id="printToolButton"
                          type="button"
                          aria-label="'Pen'"
                          [theme]="'blackText'"
                          [iconName]="zbpIconNames.printer"
                          (click)="printImage()">
    </zbp-button-component>
  </div>
</div>
